import {
    FeedbackForm,
    FeedbackSubmission,
    FeedbackFormType,
} from "../pages/FeedbackPage/types";
import { db } from "./firebase";
import {
    collection,
    doc,
    getDoc,
    query,
    where,
    getDocs,
    addDoc,
} from "firebase/firestore";

export const getFeedbackFormByTitle = async (
    title: string
): Promise<FeedbackForm | null> => {
    try {
        const feedbackFormsRef = collection(db, "feedbackForms");
        const q = query(feedbackFormsRef, where("title", "==", title));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            return null;
        }

        const doc = querySnapshot.docs[0];
        return {
            id: doc.id,
            ...doc.data(),
        } as FeedbackForm;
    } catch (error) {
        console.error("Error fetching feedback form:", error);
        throw error;
    }
};

export const submitFeedbackResponse = async (
    formId: string,
    userId: string,
    responseData: Omit<FeedbackSubmission, "formId" | "userId">
): Promise<void> => {
    try {
        // Add to userSubmittedFeedback collection
        const userFeedbackRef = collection(db, "userSubmittedFeedback");
        await addDoc(userFeedbackRef, {
            userId,
            formId,
            responses: responseData.responses,
            submittedAt: new Date(),
            title: "Survey Feedback",
        });
    } catch (error) {
        console.error("Error submitting feedback:", error);
        throw error;
    }
};

export const FEEDBACK_FORM_TITLES = {
    TECHNICAL_SUPPORT: "Technical Support",
} as const;
